import React from 'react';
import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import { Container, Typography, Divider } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  dot: {
    width: '16px',
    height: '16px',
    borderRadius: '50px',
    margin: '8px',
  },
});

const HelpTextBox = function HelpTextBox() {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Container sx={{ paddingBottom: 2 }}>
      <Typography mt={1} mb={2} variant="h6">
        {intl.messages.HELP.toUpperCase()}
      </Typography>
      <Typography variant="body1">{intl.messages.AREA_TITLE}</Typography>
      <Typography mt={0.5} mb={2}>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{intl.messages.AREA_THEMES}</ReactMarkdown>
      </Typography>
      <Divider variant="medium" />
      <Typography mt={2} variant="body1">
        {intl.messages.DEFINITIONS}
      </Typography>
      <Typography mt={0.5} mb={2}>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{intl.messages.KPI}</ReactMarkdown>
      </Typography>
      <Divider />
      <Typography mt={2} mb={2} variant="body1">
        {intl.messages.RATE}
      </Typography>
      <div className={classes.row}>
        <div className={classes.dot} style={{ backgroundColor: '#8BDB2D' }} />
        <Typography variant="subtitle1">{intl.messages.LOW_RATE}</Typography>
      </div>
      <div className={classes.row}>
        <div className={classes.dot} style={{ backgroundColor: '#F5A623' }} />
        <Typography variant="subtitle1">{intl.messages.MEDIUM_RATE}</Typography>
      </div>
      <div className={classes.row}>
        <div className={classes.dot} style={{ backgroundColor: '#D0021B' }} />
        <Typography variant="subtitle1">{intl.messages.HIGH_RATE}</Typography>
      </div>
    </Container>
  );
};

export default HelpTextBox;
